/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function(Module, $, SCS) {
	'use strict';

	var MIME_SUFFIXES = {
		'application/pdf': 'PDF',
		'application/msword': 'DOC',
		'application/excel': 'XLS',
		'application/vnd.ms-excel': 'XLS',
		'application/x-excel': 'XLS',
		'application/x-msexcel': 'XLS',
		'application/mspowerpoint': 'PPT',
		'application/powerpoint': 'PPT',
		'application/vnd.ms-powerpoint': 'PPT',
		'application/x-mspowerpoint': 'PPT',
		'text/plain': 'TXT',
		'application/rtf': 'RTF',
		'application/x-rtf': 'RTF',
		'text/richtext': 'RTF',
		'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'DOCX',
		'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'XLSX',
		'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'PPTX'
	};

	var STAR = '★';

	// Normalizes URLs from search results for the purposes of de-duplication:
	// • Remove selectors
	// • Remove query params and hash params
	// • Remove product specifiers for family pages
	function normalizeURL(url) {
		var index;

		index = url.indexOf('#');
		if(index > -1) {
			url = url.substring(0, index);
		}
		index = url.indexOf('?');
		if(index > -1) {
			url = url.substring(0, index);
		}
		url = url.split('/');

		var lastPart = url.pop();
		// Remove product family item specifier (e.g. `(N_NATEL RES 2.0 XL,24,000000000010247106)`)
		lastPart = lastPart.replace(/\([^()]+\)/, '');
		// Remove selectors
		lastPart = lastPart.split('.');
		var extension = lastPart.pop();
		lastPart = lastPart.slice(0, 1);
		lastPart.push(extension);
		url.push(lastPart.join('.'));

		return url.join('/');
	}

	var SearchResultDisplay = Module.extend({
		// The container module instance (for setting config changes and the like)
		searchContainer: null,
		// The search processor instance for this specific search result accordion with its GSA sites and client
		searchProcessor: null,
		// The current page we’re on
		pageNumber: 0,
		// The previous results
		prevResults: [],
		// Mapping from categoru names to iconfont characters
		iconMap: null,
		// If this is the only SearchResultDisplay in the current SearchResultContainer
		isSingle: false,
		// The SearchResultTitle component to display titles in (if isSingle is true)
		titleModule: null,
		// The last-recently loaded data
		currentData: {},
		// The last-recently loaded config
		currentConfig: {},
		// URLs of all last-recently loaded keymatches (for deduplication)
		currentDisplayedKeymatchURLs: {},
		// The element the search config is on
		$config: null,
		// Display the search results with images and ratings 
		enhancedResults: false,
		// True when findelements got called before
		foundElements : false,

		on: function(callback) {
			callback();
		},

		after: function() {
			this.findElements();
			this.attachListeners();

			var $accordionTitle = this.$ctx.find('.scs-sitesearch-accordion-title');
			if(!$accordionTitle.text().trim()) {
				$accordionTitle.hide();
			}			
		},

		initSearch: function(searchContainer) {
			var mod = this;
		
			this.findElements();
			mod.searchContainer = searchContainer;

			// Do communication
			var siblings = searchContainer.internalModulesByName('SearchResultDisplay');

			mod.isSingle = siblings.length === 1 && siblings[0] === mod;
			if(mod.isSingle) {
				mod.titleModule = searchContainer.internalModulesByName('SearchResultTitle')[0];
			}

			if(mod.isSingle && mod.enhancedResults) {
				searchContainer.$ctx.addClass('scs-sitesearch-enhanced-results');
			}

			mod.$config = mod.$ctx.closest('.search-configuration');
			if(!mod.$config.length) {
				// Configuration on search field could also be outside
				mod.$config = searchContainer.$config;
			}

			mod.initSearchProcessor();
		},

		searchConfigChanged: function(searchConfig) {
			this.pageNumber = 0;
			this.process(searchConfig);
		},

		process: function(config) {
			config.page = this.pageNumber;
			this.searchContainer.startLoading();
			this.searchProcessor.process(config);
		},

		findElements: function() {
			// only do that once
			if(this.foundElements) {
				return;
			}
			this.foundElements = true;
			this.resultContainer = this.$ctx.find('.scs-sitesearch-accordion-content-first-results')[0];
			this.additionalResultsContainer = this.$ctx.find('.scs-sitesearch-accordion-content-more-results')[0];
			this.$titleContainer = this.$ctx.find('.title-container');
			this.title = this.$titleContainer.text();
			this.titleFormat = this.$ctx.attr('data-sitesearch-title-format');
			this.enhancedResults = this.$ctx.data('sitesearch-enable-enhanced-results');

			this.iconMap = {};
			try {
				var icons = this.$ctx.attr('data-sitesearch-category-icons');
				if(icons) {
					this.iconMap = window.JSON.parse(icons);
				}
			} catch(e) {}

			var $textContainer = this.$ctx.closest('.scs-sitesearch-accordion-box');
			this.translations = $textContainer.data();
		},

		initSearchProcessor: function() {
			var mod = this;
			var defaults = {};
			var resultLimit = parseInt(mod.$ctx.attr('data-sitesearch-shownResults'), 10);
			if(!isNaN(resultLimit)) {
				defaults.resultLimit = resultLimit;
			}
			mod.searchProcessor = mod.createSearchProcessor(defaults);
			mod.searchProcessor.responder(SCS.search.util.respondTo({
				data: mod.searchData
			}, mod));
			mod.searchProcessor.responder(SCS.search.util.respondTo({
				data: mod.searchContainer.stopLoading,
				error: mod.searchContainer.stopLoading,
				abort: mod.searchContainer.stopLoading
			}, mod.searchContainer));
		},

		createSearchProcessor: function(defaults) {
			return SCS.search.orchestration.forSerp(
				this.$config.attr('data-sitesearch-gsahostname'),
				this.$config.attr('data-sitesearch-sites'),
				this.$config.attr('data-sitesearch-client'),
				$('html').attr('lang') || 'de',
				defaults
			);
		},

		// Got search data
		searchData: function(processor, data, config) {
			var mod = this;

			// Update the query and filter if they changed (when auto-unfiltering)
			mod.searchContainer.query = config.query;
			mod.searchContainer.filter = config.filter;
			mod.searchContainer.configUpdated();

			mod.currentConfig = config;

			// Update the title
			if(mod.titleModule) {
				mod.titleModule.searchDataAvailable(processor, data, config);
			}

			// Update resultDisplay
			mod.dataUpdated(data);
		},

		dataUpdated: function(data, displayedKeymatchURLs) {
			if(data) {
				this.currentData = data;
			}
			if(displayedKeymatchURLs) {
				this.currentDisplayedKeymatchURLs = displayedKeymatchURLs;
			}

			this.display();
		},

		attachListeners: function() {
			var mod = this;
			// Legacy accordion handling
			if(mod.$ctx.is('.scs-sitesearch-accordion-closed, .scs-sitesearch-accordion-opened')) {
				mod.$ctx.find('.scs-sitesearch-accordion-title').on('click', function() {
					mod.$ctx.toggleClass('scs-sitesearch-accordion-closed').toggleClass('scs-sitesearch-accordion-opened');
				});
			}
		},

		display: function() {
			var mod = this;

			var data = mod.currentData;
			var config = mod.currentConfig;

			var results = data.results || data.items || [];
			if(config.page > 0) {
				results = mod.prevResults.concat(results);
			}
			mod.prevResults = results;

			var snabbdom = window.snabbdom;
			var h = snabbdom.h;
			var SearchResultContainer = Module.SearchResultContainer;

			// Result container is initially hidden (before the first search was performed)
			mod.$ctx.removeClass('hidden');

			var resultCount = data.resultCount || 0;

			mod.$titleContainer.text(SCS.utils.formatString(
				mod.titleFormat,
				config.query,
				resultCount,
				mod.title
			));

			var content;
			var hasResults = resultCount > 0;
			mod.$ctx.toggleClass('scs-sitesearch-has-results', hasResults).toggleClass('has-results', hasResults).toggleClass('scs-sitesearch-no-results', !hasResults);

			if(hasResults) {
				content = mod.renderResults(results, config, h, SearchResultContainer);
			} else {
				content = mod.renderNoResultsMessage(config.query, h);
			}
			mod.resultContainer = snabbdom.patch(mod.resultContainer, h('div.scs-sitesearch-accordion-content-first-results', content));

			mod.renderPaging(data, config, resultCount, results, snabbdom, SearchResultContainer);
		},

		renderResults: function(results, config, h, SearchResultContainer) {
			var mod = this;

			// Start with spellcheck messages (if any)
			var result = mod.renderSpellcheckMessage(config, h, SearchResultContainer);

			for(var i=0;i<results.length;i+=1) {
				var item = mod.renderItem(results[i], config, h, SearchResultContainer);
				if(item) {
					result.push(item);
				}
			}
			return result;
		},

		renderSpellcheckMessage: function(config, h, SearchResultContainer) {
			var mod = this;

			var messages = [];

			if(mod.titleModule) {
				// Let the title module render these messages
				return messages;
			}

			if(config.autoCorrectedFrom) {
				messages.push(h('div.scs-sitesearch-misspelled-link', [SCS.utils.formatString(
					mod.translations.sitesearchNoresultsformisspelled,
					config.autoCorrectedFrom
				)]));
			}

			if(config.manualCorrectionSuggestion) {
				var newQuery = config.manualCorrectionSuggestion;
				messages.push(h(
					'a.scs-sitesearch-misspelled-link',
					{
						props: {
							href: window.location.pathname + '#q=' + encodeURIComponent(newQuery)
						},
						on: {
							click: function(event) {
								SearchResultContainer.trackClick('spell', config, {query: newQuery, previousQuery: config.query}, mod.searchProcessor);
								event.preventDefault();
								if(mod.isSingle) {
									// Update the whole container if we are the only module displaying search results
									mod.searchContainer.query = newQuery;
									mod.searchContainer.configChanged();
								} else {
									// Otherwise, only update this result display module
									mod.pageNumber = 0;
									mod.process(SCS.search.util.extend({}, config.inputConfig, {query: newQuery}));
								}
							}
						}
					},
					[SCS.utils.formatString(
						mod.translations.sitesearchDidyoumean,
						newQuery
					)]
				));
			}

			return messages;
		},

		renderItem: function(result, config, h, SearchResultContainer) {
			var mod = this;

			var displayedKeymatchURLs = mod.currentDisplayedKeymatchURLs;
			var url = result.url || result.link || '#';
			// Deduplicate search results that already appear as keymatches
			if(normalizeURL(url) in displayedKeymatchURLs) {
				return null;
			}

			var isEnhanced = mod.enhancedResults;
			var title = 'htmlTitle' in result ? result.title : SearchResultContainer.unsafelyStripHTML(result.title);
			var mime = String(result.mimeType || '').toLowerCase();
			if(mime in MIME_SUFFIXES) {
				title += ' ['+MIME_SUFFIXES[result.mimeType]+']';
			}
			var content = [
				h(
					'a.scs-sitesearch-accordion-searchlink',
					{
						props: {
							href: url
						},
						on: {
							click: function() {
								// Track click
								SearchResultContainer.trackClick('c', config, result, mod.searchProcessor);
							}
						}
					},
					title
				),
				h(
					'div',
					SearchResultContainer.snippetToVDomElements(result.htmlSnippet || result.snippet, h)
				)
			];
			if(isEnhanced) {
				var reviews = mod.renderReviews(result, h);
				if(reviews) {
					content.push(reviews);
				}

				// Wrap enhanced results in a group
				content = h('div.scs-result-item-content', content);
				var icon = mod.getIcon(result);
				if(icon && icon.src) {
					icon = h('img', {props: {src: icon.src}});
				} else if(icon && icon.icon && icon.icon in mod.iconMap) {
					icon = h('span.iconfont.glyph', [mod.iconMap[icon.icon]]);
				} else {
					icon = null;
				}
				if(icon) {
					// Prepend icon to group
					content = [h('div.scs-result-item-icon', [icon]), content];
				} else {
					content = [content];
				}
			}
			return h(
				'div.scs-result-item',
				content
			);
		},

		renderReviews: function(result, h) {
			if(!result.meta) {
				return;
			}
			// FIXME NEC: Is there a spec for this? Rating seems to be an integer [10..50]
			var rating = Math.max(0, Math.min(5, parseFloat(result.meta.ratingValue) / 10));
			var count = parseInt(result.meta.ratingCount, 10);
			if(!rating || !count) {
				return;
			}

			var fullStars = Math.floor(rating);
			var halfStar = rating - fullStars;
			var emptyStars = 5 - fullStars - Math.ceil(halfStar);

			var stars = [], i;

			for(i=0;i<fullStars;i+=1) {
				stars.push(h('div.star.iconfont.glyph', [STAR]));
			}
			if(halfStar) {
				stars.push(h(
					'div.star.gray.iconfont.glyph',
					[
						STAR,
						h(
							'div.star.halfFilled.iconfont.glyph',
							{
								style:
								{
									width: (18*halfStar)+'px'
									// FIXME: Test with em and get rid of magic 18px = 100%
									// width: halfStar+'em'
								}
							},
							[STAR]
						)
					]
				));
			}
			for(i=0;i<emptyStars;i+=1) {
				stars.push(h('div.star.gray.iconfont.glyph', [STAR]));
			}

			return h(
				'div.scs-result-item-review',
				[
					h(
						'div.scs-result-item-review-stars',
						stars
					),
					h(
						'div.starstext',
						[SCS.utils.formatString(
							this.translations.sitesearchRatingsTitle,
							count
						)]
					)
				]
			);
		},

		renderNoResultsMessage: function(query, h) {
			if(this.titleModule) {
				// Let the title module render these messages
				return [];
			}
			return [
				h('span.scs-noresults-icon'),
				h('span.scs-sitesearch-no-results-content', [SCS.utils.formatString(
					this.translations.sitesearchNoresultsglobal,
					query,
					this.title
				)])
			];
		},

		renderPaging: function(data, config, resultCount, results, snabbdom, SearchResultContainer) {
			var mod = this;
			var h = snabbdom.h;
			// Add more results button and info
			var remaining = resultCount - (config.offset + results.length);

			var pagingControls = [];

			if(remaining > 0) {
				var nextPageStart = config.offset + config.resultLimit + 1;
				var nextPageEnd = Math.min(nextPageStart + config.resultLimit - 1, resultCount);
				pagingControls = [
					h(
						'div.scs-sitesearch-moreresults.secondary-button.button-secondary',
						{
							on: {
								click: function() {
									// Track click
									SearchResultContainer.trackClick('nav.next', config, {url: document.location.href, page: config.page + 1, previousPage: config.page}, mod.searchProcessor);
									// Load next page
									mod.pageNumber = config.page + 1;
									mod.process(SCS.search.util.extend({}, config.inputConfig));
								}
							}
						},
						[mod.translations.sitesearchMorebuttontext]
					),
					h(
						'div.scs-sitesearch-moreresults-info',
						[
							SCS.utils.formatString(
								mod.translations.sitesearchMorebuttontextInfo,
								nextPageStart,
								nextPageEnd,
								resultCount
							)
						]
					),
					h('hr')
				];
			}

			mod.additionalResultsContainer = snabbdom.patch(mod.additionalResultsContainer, h('div.scs-sitesearch-accordion-content-more-results', pagingControls));
		},

		getIcon: function(result) {
			// jshint camelcase: false
			var meta = result.meta;
			if(!meta) {
				return;
			}
			if(meta.thumbnail) {
				return {src: result.meta.thumbnail};
			} else if(meta.gsaentity_GSA_Category) {
				return {icon: meta.gsaentity_GSA_Category};
			}
		}

	});

	SearchResultDisplay.normalizeURL = normalizeURL;

	Module.SearchResultDisplay = SearchResultDisplay;

})(window.Tc.Module, window.Tc.$, window.SCS = window.SCS || {});

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.SearchResultDisplay.js
// module id = 316
// module chunks = 0